import { type InmateContactFilters } from '@reliance/types/filters/InmateContactFilters';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type InmateContactResult } from '@reliance/types/models/InmateContact';
import { type ApiService } from '../types/ApiService';

export const inmateContact = (siteApi: ApiService, centralApi: ApiService) => ({
  index: (
    params: Partial<InmateContactFilters>,
  ): Promise<PaginatedResponse<InmateContactResult>> => {
    return siteApi.get('/inmate-contact', { params });
  },
  post: (data: object): Promise<InmateContactResult> => {
    return centralApi.post('/inmate-contact', data);
  },
  put: (id: number, data: object): Promise<{ success: boolean }> => {
    return centralApi.put(`/inmate-contact/by-id/${id}`, data);
  },
});
